import { networkState } from './network-state';

export function isDocumentHidden(): boolean {
  return typeof document !== 'undefined' && document.visibilityState === 'hidden';
}

export function isNetworkOffline(): boolean {
  return !networkState.isOnline();
}

export function waitForNetwork(signal?: AbortSignal): Promise<void> {
  return networkState.waitForOnline(signal);
}

export function waitForVisibility(signal?: AbortSignal): Promise<void> {
  if (typeof document === 'undefined' || !isDocumentHidden()) {
    return Promise.resolve();
  }

  if (signal?.aborted) {
    return Promise.reject(signal.reason ?? new DOMException('Aborted', 'AbortError'));
  }

  return new Promise((resolve, reject) => {
    const controller = new AbortController();

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        controller.abort();
        resolve();
      }
    };

    const onAbort = () => {
      controller.abort();
      reject(signal!.reason ?? new DOMException('Aborted', 'AbortError'));
    };

    document.addEventListener('visibilitychange', onVisibilityChange, {
      signal: controller.signal,
    });
    signal?.addEventListener('abort', onAbort, { signal: controller.signal });
  });
}
